import { InlineImage } from "../../components/InlineImage";
import { MenuItem } from "../../components/Menu";

/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function WieIsDeMolOnline() {
  return (
    <div>
      <div className="box light">
        <div className="left">
          <h1>Wie is de Mol Online (2020-2022)</h1>
          <p>
            Toen in 2020 de Corona golf het sociale leven in Nederland op zijn kop zette en je vrienden voornamelijk alleen nog 'online' zag, ontstond zo maar aan de ontbijttafel
            het idee van een Wie is de Mol spel, maar dan geheel online. Ik ging met het idee aan de slag en al snel zat ik iedere avond een paar uur op zolder o mte werken aan dit
            nieuwe spel. In december 2020 was het dan zover; het eerste seizoen ging van start. Destijds was dit de trailer om het spel aan te kondigen.
          </p>
        </div>
        <div className="right">
          <video width="100%" controls>
            <source src="https://ladagevandoorn.nl/assets/video/widmol-trailer-seizoen1.m4v" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      <div className="box main">
        <div className="left">
          <h1>Seizoen 1 (2020/2021)</h1>
          <p>
            In het eerste seizoen was Aldert de Mol en hij speelde tegen 9 kandidaten. Het prijzengeld van € 200 werd verdeeld over de winnaar en de Mol. In de finale zaten Aldert,
            Onze Marion en Meike. In die laatste test hadden Marion en Meike beide 14 van de 20 vragen goed. Onze Marion had daar 7 minuten en 17 seconden voor nodig, Meike 7
            minuten en 56 seconden. En dus was Onze Marion net iets sneller, en won daarmee het spel. Onze Marion won daarmee € 136,19. Voor de Mol Aldert bleef er € 63,81 over.
          </p>
        </div>
        <div className="right">
          <InlineImage image="spellen/widmol/kandidaten-seizoen1.png" subscript="Kandidaten seizoen 1" />
        </div>
      </div>

      <div className="box light">
        <div className="left">
          <h1>Seizoen 2 (2021/2022)</h1>

          <p>
            In het tweede seizoen was Lies de Mol, en ook zij speelde tegen 9 kandidaten. Ook nu was zat er € 200 in de prijzenpot, en werd dat bedrag verdeeld over de winnaar en
            de Mol. De opdrachten waren grotendeels hetzelfde, maar de onderliggende techniek was behoorlijk aangepast (zie onder). In de finale zaten Lies, Tineke en Sophie. In de
            finale test had Tineke 21 vragen goed van de 25, en Sophie 20. Daarmee won Tineke het spel en werd de winnaar van seizoen 2. Tineke won daarmee € 163,07. Voor de Mol
            Lies bleef er (slechts) € 36,93 over.
          </p>
        </div>
        <div className="right">
          <InlineImage width={400} image="spellen/widmol/kandidaten-seizoen2.png" subscript="Kandidaten seizoen 2" />
        </div>
      </div>

      <div className="box main">
        <div className="row">
          <h1>Spelregels</h1>
          <h2>Opdrachten</h2>
          <p>
            De deelnemers krijgen iedere week een opdracht, die vaak uit meerdere delen bestaat. Met deze opdrachten kan er geld verdiend worden voor de pot. De Mol doet er alles
            aan om deze opdrachten te laten mislukken zodat er geen, of veel minder, geld in de pot komt. De Mol is dus de saboteur van de groep. Na elke opdracht moeten de
            deelnemers een test maken. Een ronde bestaat dus uit een opdracht en een test. In deze test, die bestaat uit 15 vragen, worden de deelnemers gevraagd naar de identiteit
            en het doen en laten van de Mol. De deelnemers die het minst weet ligt uit het spel... behalve de Mol... die hoeft nooit naar huis.
          </p>

          <h2>Spelelementen</h2>
          <p>Wie is de Mol Online beschikt over verschillende spelelementen. Er zijn jokers, groene en zwarte vrijstellingen te vinden in het spel.</p>
          <ul>
            <li>
              <b>Joker</b>: Een joker maakt één fout antwoord in de test goed. Jokers kunnen in het laatste onderdeel van de test ingezet worden.
            </li>
            <li>
              <b>Groene vrijstelling</b>: Met een groene vrijstelling ben je verzekerd van een plaats in de volgende ronde. De groene vrijstelling kan in het laatste onderdeel van
              de test ingezet worden. Omdat er altijd door een andere deelnemer een zwarte vrijstelling ingezet kan worden, moet je de test wel maken.
            </li>
            <li>
              <b>Zwarte vrijstelling</b>: Met een zwarte vrijstelling vervallen alle ingezette jokers en vrijstellingen. Als de zwarte vrijstelling ingezet is, heeft effectief dus
              niemand jokers of vrijstellingen ingezet. De kansen zijn voor iedereen gelijk. Ook de zwarte vrijstelling kan in het laatste onderdeel van de test ingezet worden.
            </li>
          </ul>
          <p>
            Voor alle drie geldt; ze zijn geldig <b>tot</b> aan de finale. In de test na de finale opdracht kunnen er geen jokers of vrijstellingen meer ingezet worden.
          </p>

          <h2>De pot</h2>
          <p>
            Het geld dat de deelnemers verdienen bij de opdrachten wordt verzameld in een centrale pot. De huidige balans van de pot is voor iedere deelnemer op ieder moment
            zichtbaar, bovenin het scherm (zie ook Menubalk). Indien er tijdens een opdracht geld in de pot komt wordt dit direct in de menubalk bijgewerkt.
          </p>
          <p>
            In de meeste gevallen echter, wordt verdiend geld niet direct toegevoegd aan de pot maar wordt het verdiende geld eerst overgemaakt naar de penningmeester. De
            penningmeester verzamelt al het geld en maakt het vervolgens over aan de pot. Althans, dat <i>kan</i> de penningmeester doen. Maar of de penningmeester te vertrouwen
            is, dat weten alleen de Mol en de penningmeester zelf...
          </p>

          <h2>De finale</h2>
          <p>
            In de finale zijn er nog 3 deelnemers over; de Mol en 2 kandidaten. Zij spelen de allerlaatste opdracht en doen na afloop de allerlaatste test. Na afloop van die test
            is de einduitslag bekend; de deelnemer die de meeste vragen goed beantwoord heeft wint het spel en is de winnaar van dit seizoen.
          </p>
          <p>
            Na de finale en laatste test volgt er nog een laatste bijeenkomst, waarbij alle voorgaande kandidaten ook weer aanwezig zijn. Bij die bijeenkomst wordt ontmaskerd wie
            de Mol is, en wordt het prijzengeld van de winnaar en de Mol bekend gemaakt. Bij Wie is de Mol Online delen de winnaar en de Mol namelijk het prijzengeld. Zit er weinig
            geld in de pot en is de Mol onopgemerkt gebleven (bij de test zijn er weinig vragen goed beantwoord), dan wint de Mol een groot deel van het prijzengeld van &euro;200,
            en de winnaar een klein deel. Andersom, als er veel geld in de pot zit en er veel vragen over de Mol juist beantwoord zijn, krijgt de winnaar een groot deel van het
            prijzengeld, en de Mol een klein deel.
          </p>
        </div>
      </div>

      <div className="box light">
        <div className="left">
          <h1>De Techniek - seizoen 1</h1>
          <p>
            Wie is de Mol Online seizoen 1 werd volledig gehost op een Synology DS216+. Op een Synology NAS draait Linux, met daarop een specifiek Synology besturingssysteem
            genaamd DSM. Binnen DSM draaide een webserver (Apache HTTP Server met PHP) en een MariaDB database. De gehele omgeving was geïmplementeerd in PHP, met een beetje
            jQuery. Het applicatielandschap was daarmee zeer eenvoudig; frontend requests kwam binnen op de webserver en vanuit daar werden waar nodig SQL queries uitgevoerd op de
            Maria database.
          </p>
          <p>
            Alhoewel dit in de basis prima werkte, was het voor het spel echt noodzakelijk om twee-weg communicatie mogelijk te maken. Een manier waarop de 'server' zelf ook actief
            berichten kan sturen naar de client, of deze zelfs kan besturen. Websockets was daar een goede optie voor geweest, maar dat was in de technology stack van seizoen 1 nog
            niet beschikbaar. Op sommige plaatsen werd er noodgedwongen een 'Ajax ping' gedaan naar de server iedere seconde, puur om te checken of er "nieuwe berichten" waren.
          </p>
        </div>
        <div className="right">
          <InlineImage image="spellen/widmol/arch_season_1.png" subscript="Architectuur seizoen 1" />
        </div>
      </div>
      <div className="box main">
        <div className="left">
          <h1>De Techniek - seizoen 2</h1>
          <p>
            Seizoen 1 was dus voornamelijk in PHP geprogrammeerd, maar dat is niet mijn expertise. Beroepsmatig gebruik ik voornamelijk Java, en dus was het voor mij een veel
            efficiëntere keus om Java te gebruiken. Daarnaast biedt Java meer mogelijkheden dan PHP. Een rewrite van het server-side deel naar Java was dan ook een voor de hand
            liggende keuze voor seizoen 2. Een ander uitgangspunt in seizoen 2 was dat alle handelingen tijdens de opdrachten geautomatiseerd waren, zodat de spelleider tijdens de
            opdracht zelf slechts achterover hoefde te leunen.
          </p>
          <p>
            De belangrijkste wijziging in seizoen 2 was de splitsing in een frontend applicatie en een backend applicatie. De frontend bleef PHP, server-side werd Java. Daarbij
            koos ik voor een OSGi Java applicatie (incl. Websockets) op een Apache Karaf runtime, met JPA als persistence laag om met de Maria database te communiceren. Deze
            splitsing gaf ook de nodige hoofdpijn, omdat de client nu cross-site Ajax requests moest uitvoeren. De PHP webserver draait op wieisdemolonline.nl, de Java server op
            api.wieisdemolonline.nl. Wel geeft dit een mooie scheiding tussen frontend en (headless) backend.
          </p>
          <p>
            Apache Karaf draaide in eerste instantie als Docker image binnen Docker, omdat dat binnen DSM nu eenmaal handig in het gebruik is. De combinatie van Docker en de Ajax
            preflight requests die nodig zijn vanwege de cross-site Ajax requests bleken echter een nachtmerrie.
            {/** Op de 10 requests kreeg 1 er een 502 Bad Gateway foutmelding. En
            dat is een beetje jammer, omdat daardoor bijvoorbeeld voorwerpen in het spel niet gepakt konden worden of zomaar verdwenen. Uiteindelijk bleek Docker daarbij de oorzaak
            van het probleem te zijn. Docker moest zelf de requests vanaf de Proxy server weer doorsturen naar de embedded Karaf server, maar dat ging af en toe fout. **/}
            Na Googelen op dit specifieke probleem bleek dat dit een known issue was, waarop ik besloot ik afscheid te nemen van Docker en Apache Karaf dan maar gewoon direct vanaf
            de Linux shell te draaien.
          </p>
          {/**
          <p>
            Ondertussen waren er ook performance issue met het afhandelen van de Ajax requests. Ook dit bleek deels aan Docker te liggen, of eigenlijk vooral aan de hoeveelheid
            geheugen die de NAS nodig had. De NAS was maar uitgerust met 2 GB intern geheugen, wat gewoon weg te weinig was om alles fatsoenlijk op te draaien. Officieel was 2 GB
            de max, maar met wat googelen waren al snel howto's gevonden voor een upgrade naar 8 GB. De NAS werd uitgerust met 8 GB, en het performance probleem was daarmee
            opgelost.
          </p>
           */}
          <p>
            Vanuit Karaf gebruikte ik JPA om met de Maria database te communiceren. Een extra proxy server (NGINX) was nodig om het verkeer naar api.wieisdemolonline.nl door te
            loodsen naar Karaf. Dat verkeer kan vanaf de client komen, maar ook vanuit de PHP frontend die zelf ook nog requests doet. Het architectuurplaatje ziet er in seizoen 2
            dan uiteindelijk een stuk complexer uit.
          </p>
        </div>
        <div className="right">
          <InlineImage image="spellen/widmol/arch_season_2.png" subscript="Architectuur seizoen 2" />
        </div>
      </div>

      <div className="box light">
        <div className="row">
          <h1>De Techniek - overige tooling</h1>
          <p>Tot slot dan nog even een overzicht van de overige tools en libraries die ik gebruikte.</p>

          <h2>Jitsi meet</h2>
          <p>
            De kandidaten logden bij iedere opdracht in op Jitsi meet, gratis gehost via één van de online Jitsi servers. Jitsi heeft een redelijk uitgebreide JavaScript API,
            waardoor je meerdere ruimtes kunt maken en kandidaten naar de juiste ruimte kan sturen. Een 'widmol bot' was standaard aanwezig in iedere ruimte om de Jitsi recording
            aan te zetten, en deze op te slaan op Dropbox. Zo kon ik achteraf alles terugzien wat er in iedere afzonderlijke ruimte gebeurd was, en dit gebruiken in een
            filmcompilatie.
          </p>

          <h2>Google streetview/maps</h2>
          <p>
            Veel opdrachten gebruikten de Google Maps en Streetview API om kandidaten virtueel door steden, kathedralen, enz. te laten wandelen. In Streetview kun je via de API
            objecten projecteren op specifieke locaties. Op die manier kun je dus geld en jokers op specifieke plekken leggen, die de kandidaten vervolgens op kunnen pakken. De
            virtuele GPS locatie werd server-side bijgehouden, zodat bijvoorbeeld de spelleider in Google Maps de locaties van alle spelers kon zien. Voor deze API is een betaald
            account nodig, maar bij de hoeveelheden requests die voor deze opdrachten nodig waren werden er geen kosten berekend door Google.
          </p>

          <h2>Font Awesome</h2>
          <p>
            Font awesome biedt een groot assortiment aan gratis te gebruiken iconen. Daar ikzelf geen UX designer ben, en ook niet die ambitie heb, heb ik veel gebruik gemaakt van
            gratis iconen die door Font Awesome aangeboden worden.
          </p>
        </div>
      </div>
    </div>
  );
}

export default WieIsDeMolOnline;
